import { render, staticRenderFns } from "./NavProfile.vue?vue&type=template&id=168763b2&scoped=true"
import script from "./NavProfile.vue?vue&type=script&lang=js"
export * from "./NavProfile.vue?vue&type=script&lang=js"
import style0 from "./NavProfile.vue?vue&type=style&index=0&id=168763b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168763b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default})
